<template>
  <section v-if="!isEmptySlide" :class="[style['slide-container']]">
    <figure :class="style.slide">
      <div
        v-if="hasImage || showFallbackImage"
        :class="[style['slider-img-container'], hasImage ? '' : style.fallback]"
      >
        <img v-if="hasImage" :class="[style.img]" :src="displayImage" @error="handleImageError" />
      </div>

      <figcaption :class="[style.body]">
        <div :class="style['title-block']">
          <h4 v-if="slide.title" :class="style.title" v-html="slide.title.content"></h4>
          <div
            v-if="slide.subtitle"
            :class="[style.subtitle]"
            v-html="slide.subtitle.content"
          ></div>
        </div>

        <div v-if="slide.body" :class="[style.content]">
          <slider-expandable-block
            ><div style="font-size: 16px" v-html="slide.body.content"></div
          ></slider-expandable-block>
        </div>
      </figcaption>

      <ul v-if="!isMultipleSelector" :class="style['action-container']">
        <li :class="style.action">
          <theme-button
            v-if="slide.submit_button"
            square
            block
            :disabled="disabled"
            @click="sendReply"
            >{{ slide.submit_button.content }}</theme-button
          >
          <a v-if="slide.open_url_button" :href="slide.open_url_button.value" target="_blank">
            <theme-button square block>{{ slide.open_url_button.content }}</theme-button>
          </a>
        </li>
      </ul>
      <ul v-else :class="style['action-container']" style="display: flex">
        <li style="width: 20%">
          <theme-button square block :disabled="disabled" @click="decrement">-</theme-button>
        </li>
        <li :class="style.action" style="width: 60%">
          <theme-button square block :disabled="disabled">{{ quantity }}</theme-button>
        </li>
        <li style="width: 20%">
          <theme-button square block :disabled="disabled" @click="increment">+</theme-button>
        </li>
      </ul>
    </figure>
  </section>
</template>

<script>
import style from './scss/_slider.scss'
import { Chat } from 'src/apis'
import _every from 'lodash/every'
import ThemeButton from 'javascript/Common/ThemeButton'
import SliderExpandableBlock from 'UtilityComponents/SliderExpanableBlock'
import { touristImgPlaceholder } from 'javascript/Constants'

export default {
  name: 'SliderBot',

  components: {
    SliderExpandableBlock,
    ThemeButton
  },

  props: {
    disabled: Boolean,
    showFallbackImage: Boolean,
    slide: {
      type: Object,
      required: true
    },
    chat: {
      type: Object,
      required: true
    },
    isMultipleSelector: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      style,
      isOverflow: false,
      showMore: false,
      quantity: 0,
      imgUrl: ''
    }
  },

  computed: {
    displayImage() {
      return this.imgUrl || this.slide.main_image.content
    },

    isEmptySlide() {
      return _every(this.slide, (attribute, key) => {
        if (key === 'submit_button') return true

        return attribute.content === null
      })
    },

    hasImage() {
      return this.slide.main_image && this.slide.main_image.content
    }
  },

  methods: {
    sendReply() {
      this.$emit('replied')
      Chat.sendMessage('', {
        customBotFormFields: [
          {
            ...this.slide.submit_button
          }
        ]
      })
    },
    increment() {
      if (!this.disabled) {
        this.quantity++
        this.$emit('updateQuantity', this.quantity)
      }
    },
    decrement() {
      if (!this.disabled && this.quantity > 0) {
        this.quantity--
        this.$emit('updateQuantity', this.quantity)
      }
    },
    handleImageError() {
      this.imgUrl = this.slide.placeholder_image_url.content || touristImgPlaceholder
    }
  }
}
</script>
